import { Download, Loader } from 'lucide-react'
import { useTransition } from 'react'
import { toast } from 'sonner'
import { ToasterContent } from '@/components/sv/toaster-content'
import { TOKEN_KEY } from '@/config/local-storage'

const downloadFromUrl = (url: string, fileName: string) => {
  const link = document.createElement('a')
  link.setAttribute('href', url)
  link.setAttribute('download', fileName)
  document.body.appendChild(link)
  link.click()
  link.parentNode?.removeChild(link)
}

export const DownloadInvoice = ({
  id,
  invoiceNumber,
  idCompany,
}: {
  id: string
  invoiceNumber: string
  idCompany: string
}) => {
  const [isPending, startTransition] = useTransition()

  return isPending ? (
    <Loader className="animate-spin size-4" />
  ) : (
    <Download
      onClick={() =>
        startTransition(async () => {
          try {
            const fileName = `sevalla_${invoiceNumber}.pdf`
            const url = `https://my.kinsta.com/print_invoice/${id}?idCompany=${idCompany}`
            const response = await fetch(url, {
              headers: { 'x-token': localStorage.getItem(TOKEN_KEY) || '' },
            })

            if (response.ok) {
              const blob = await response.blob()
              const downloadUrl = window.URL.createObjectURL(new Blob([blob]))
              downloadFromUrl(downloadUrl, fileName)
            }
          } catch {
            toast(
              <ToasterContent variant="error">
                Failed to download invoice
              </ToasterContent>,
              { position: 'top-right' }
            )
          }
        })
      }
      className="size-4 cursor-pointer"
    />
  )
}
